import { HTTP } from '../../utils'

export const getGroup = (uuid) => {
  return HTTP().get('group/' + uuid)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const findGroups = (page, count) => {
  let url = '/group/search?page=' + page + '&count=' + count
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/group/api.js